<template>
  <div class="page">
    <!-- 验证域名 -->
    <template v-if="step === 0">
      <div class="condition-section">
        <div class="row">
          <div class="name">请填写您要转出的域名：</div>
          <Input
            class="height60"
            v-model="form.domainName"
            placeholder="请输入搜索的域名名称"
            style="width: 300px"
            clearable
          />
          <Button
            :loading="step1Loading"
            type="primary"
            style="height: 60px; margin-left: 20px; width: 100px"
            @click="stepNext()"
            >下一步</Button
          >
        </div>
      </div>
      <div class="tips">
        <h4 class="title">智绘网络域名转出条件</h4>
        <ul class="no">
          <li class="def">域名注册满60天后可以办理转移注册商。</li>
          <li class="def">cn（含长尾cn）/中国的域名距离到期前15天以上可以办理转移。</li>
          <li class="def">
            转移密码有效时间为15天，请在有效期内操作转移，如过期不操作自动视为放弃转移。
          </li>
          <li class="def">
            设置了隐私保护的域名，获取转移密码前要先取消隐私保护。
          </li>
          <li class="def">
            获取转移密码到邮箱里，可能会由于网络延迟或邮件过滤设置等原因，导致邮件延迟或收不到，建议可以垃圾邮件中查看下，或更改邮件过滤设置。
          </li>
          <li class="def">
            按照上游注册局的规则，域名转出过程需要5天时间，此时间是指客户在域名转入注册商提交正确转移密码后，且中途未对域名转出进行拒绝情况下需要的时间。
          </li>
          <li class="warn">
            若有任何疑问，请联系域名专员协助解决。联系电话：400-018-6863
            邮箱：gogoing0708@126.com
          </li>
        </ul>
      </div>
    </template>
    <!-- 验证手机号 -->
    <div v-show="step === 1">
      <div class="tips-warn">
        <img class="icon" src="@/assets/image/tips-warn.png" />
        新注域名续费60天内禁止转移!
      </div>
      <div class="content">
        <navStepList
          :value="navStepList"
          :current="navStepCurrent"
          :lineWidth="40"
        ></navStepList>
        <div class="section">
          <div class="title">为了保障您的域名安全，我们需要验证您的信息</div>
          <div class="row">
            <div class="name">手机号码：</div>
            <div>{{ mobilePhone }} 若您的手机号码已停用，请联系在线客服。</div>
          </div>
          <div class="row">
            <div class="name">验证码：</div>
            <Input
              class="height60"
              placeholder="请输入验证码"
              clearable
              v-model="form.code"
              @on-keyup="form.code = form.code.replace(/[^\d]/g, '')"
              style="width: 200px"
            >
            </Input>
            <smsBtn
              ref="smsBtn"
              height="60px"
              @tap="getCodeEvent"
              style="width: 120px; margin-left: 10px"
            ></smsBtn>
          </div>
          <div style="margin-top: 40px; margin-left: 140px">
            <Button
              :loading="step2Loading"
              type="primary"
              style="margin-right: 20px; height: 60px; width: 120px"
              @click="stepNext2()"
              >下一步</Button
            >
            <Button
              type="info"
              ghost
              style="height: 60px; width: 120px"
              @click="goBak()"
              >返回</Button
            >
          </div>
        </div>
      </div>
    </div>
    <!-- 核对邮箱 -->
    <template v-if="step === 2">
      <div class="tips-warn">
        <img class="icon" src="@/assets/image/tips-warn.png" />
        新注域名续费60天内禁止转移!
      </div>
      <div class="content">
        <navStepList
          :value="navStepList"
          :current="navStepCurrent"
          :lineWidth="40"
        ></navStepList>
        <div class="section">
          <div class="title">为了保障您的域名安全，我们需要验证您的信息</div>
          <div class="row">
            <div class="name">转出的域名：</div>
            <div>{{ form.domainName }}</div>
          </div>
          <div class="row">
            <div class="name">转移码接收邮箱：</div>
            <div>{{ email }}</div>
          </div>
          <div style="margin-top: 20px; margin-left: 140px">
            <Button
              :loading="step3Loading"
              type="primary"
              style="margin-right: 20px; height: 60px; width: 120px"
              @click="stepNext3()"
              >获取转移码</Button
            >
            <Button
              type="info"
              ghost
              style="height: 60px; width: 120px"
              @click="goBak()"
              >返回</Button
            >
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import navStepList from "components/navStepList";
import smsBtn from "components/smsBtn.vue";
import { smsSend } from "api/user.js";
import {
  transferOutCheckDomain,
  transferOutCheckMobile,
  transferOutTransferCode,
} from "api/domain.js";

export default {
  name: "transferout",
  components: {
    navStepList,
    smsBtn,
  },
  data() {
    return {
      step: 0, // 0 查询域名 1 验证手机 2 发送转移码
      navStepList: ["验证手机", "核对邮箱", "等待邮件确认", "域名转出成功"],
      navStepCurrent: 0,
      step1Loading: false,
      step2Loading: false,
      step3Loading: false,
      transferCode: "",
      email: "",
      mobilePhone: "",
      form: {
        domainName: "",
        code: "",
      },
    };
  },
  methods: {
    // 发送验证码
    getCodeEvent(callback) {
      smsSend()
        .then((res) => {
          if (res.code === 200 && res.result) {
            callback(true);
          }
        })
        .catch(() => {
          this.$refs.smsBtn.reset();
        });
    },
    // 检测域名
    async stepNext() {
      try {
        if (!this.form.domainName) {
          this.$Message.warning("请输入域名！");
          return false;
        }
        let params = {
          domainName: this.form.domainName,
        };
        this.step1Loading = true;
        const { code, data, result } = await transferOutCheckDomain(params);
        this.step1Loading = false;
        if (code === 200 && result) {
          this.navStepCurrent = 0;
          this.step = 1;
          this.transferCode = data.checkCode;
          this.email = data.email;
          this.mobilePhone = data.mobilePhone;
          this.form.domainName = data.domainName;
          this.$nextTick(() => {
            this.$refs.smsBtn.getCodeEvent();
          });
        }
      } catch (error) {
        this.step1Loading = false;
        console.log(error);
      }
    },
    // 检测手机号
    async stepNext2() {
      try {
        if (!this.transferCode) {
          this.$Message.warning("没有权限进行此次操作！");
          return;
        }
        if (this.form.code == null || this.form.code === "") {
          this.$Message.warning("请输入短信验证码！");
          return;
        }
        let params = {
          code: this.form.code,
          checkCode: this.transferCode,
        };
        this.step2Loading = true;
        const { code, data, result } = await transferOutCheckMobile(params);
        this.step2Loading = false;
        if (code === 200 && result) {
          this.transferCode = data.checkCode;
          this.email = data.email;
          this.mobilePhone = data.mobilePhone;
          this.form.domainName = data.domainName;
          this.navStepCurrent = 1;
          this.step = 2;
          this.$refs.smsBtn.reset();
        }
      } catch (error) {
        this.step2Loading = false;
        this.$refs.smsBtn.reset();
        console.log(error);
      }
    },
    // 发送转移码
    async stepNext3() {
      try {
        if (!this.transferCode) {
          this.$Message.warning("没有权限进行此次操作！");
          return;
        }
        let params = {
          checkCode: this.transferCode,
        };
        this.step3Loading = true;
        const { code, result } = await transferOutTransferCode(params);
        this.step3Loading = false;
        if (code === 200 && result) {
          this.$Message.success(
            "域名转出申请已经提交，请等待我司域名转移专员为您人工审核处理！"
          );
          this.$router.replace("/user/transferout/record");
        }
      } catch (error) {
        this.step3Loading = false;
        console.log(error);
      }
    },
    // 返回
    goBak() {
      this.step = 0;
      this.transferCode = "";
      this.email = "";
      this.mobilePhone = "";
      this.form.domainName = "";
      this.navStepCurrent = 0;
    },
  },
};
</script>

<style lang="less" scoped>
.condition-section {
  margin: 40px 0px 0;
  background-color: #fff;
  padding: 20px 50px;
}
.row {
  display: flex;
  align-items: center;
  line-height: 60px;
  .name {
    min-width: 120px;
    text-align: right;
    margin-right: 20px;
  }
}
/deep/.height60 {
  .ivu-input {
    height: 60px;
    line-height: 60px;
  }
  .ivu-input-icon {
    line-height: 60px;
  }
  .ivu-input-with-prefix {
    padding-left: 60px;
  }
  .ivu-input-prefix {
    width: 60px;
    padding: 0 10px;
  }
  .ivu-select-selection {
    height: 60px;
  }
  .ivu-select-input {
    height: 60px;
  }
  .ivu-select-selected-value {
    height: 60px;
    line-height: 60px;
  }
  .ivu-select-placeholder {
    height: 60px;
    line-height: 60px;
  }
}
.tips {
  margin: 40px 0px 0;
  background-color: #fff;
  padding: 20px 50px;
  .title {
    color: #333;
    font-size: 18px;
  }
}
.no {
  margin-left: 20px;
  margin-top: 20px;
  .def {
    line-height: 50px;
    color: #666666;
  }
  .warn {
    color: #ff5c35;
    line-height: 50px;
  }
}
.tips-warn {
  padding: 28px 50px;
  border-radius: 8px;
  color: #333333;
  font-size: 14px;
  background-color: #e9effd;
  border: 1px solid #3992e9;
  display: flex;
  align-items: center;
  .icon {
    margin-right: 20px;
    width: 20px;
    height: 19px;
  }
}
.content {
  margin-top: 40px;
  padding: 60px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  .section {
    width: 500px;
    margin: 60px auto 0;
    .title {
      color: #333333;
      line-height: 20px;
      font-weight: 400;
      font-size: 14px;
    }
  }
}
</style>
